import React, { useState } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import loadable from '@loadable/component';

import Link from 'components/consumer/Link';
import PDPMobileCarousel from 'components/consumer/PDP/PDPMobileCarousel';
import MobileModal from 'components/consumer/MobileModal';
import PDPDimensionsContent from '../PDPDimensionsContent';

const PDPMobileStudioCampaignLogo = loadable(() =>
  import('./PDPMobileStudioCampaignLogo')
);

const PDPMobileStudioPhotoGalleryUI = ({
  enableCrops = true,
  introVideoId,
  linkTo,
  mode = 'pdp',
  photos = [],
  productName,
  viewGalleryImageEvent,
  campaign,
}) => {
  const isPdpMode = mode === 'pdp';
  const isGalleryLinked = !isPdpMode && linkTo;
  const GalleryWrapper = isGalleryLinked ? Link : 'div';
  const [isDimensionsModalOpen, setIsDimensionsModalOpen] = useState(false);

  return (
    <>
      <GalleryWrapper
        className={classNames('PDPMobileStudioPhotoGalleryUI', {
          'block mt-[5px]': isGalleryLinked,
        })}
        to={isGalleryLinked ? linkTo : null}
      >
        <PDPMobileStudioCampaignLogo campaign={campaign} />

        <PDPMobileCarousel
          enableCrops={enableCrops}
          isHero
          photos={photos}
          videoId={introVideoId}
          productName={productName}
          showFavoriteButton={isPdpMode}
          onAfterSlide={idx => {
            const photo = photos[idx];
            if (photo) {
              viewGalleryImageEvent({
                imageLocation: 'Hero Gallery',
                imageFilename: photo.src?.split('/').pop() || '',
                totalImages: photos.length,
                position: idx,
              });
            }
          }}
          displayShownIn={isPdpMode}
          showARIcon
          zoomOnClick={isPdpMode}
        />
      </GalleryWrapper>

      <MobileModal
        isOpen={isDimensionsModalOpen}
        title="Dimensions"
        isFullHeight
        onClose={() => {
          setIsDimensionsModalOpen(false);
        }}
      >
        <PDPDimensionsContent />
      </MobileModal>
    </>
  );
};

PDPMobileStudioPhotoGalleryUI.propTypes = {
  enableCrops: PropTypes.bool,
  introVideoId: PropTypes.string,
  linkTo: PropTypes.string,
  mode: PropTypes.oneOf(['pdp', 'quickview']),
  photos: PropTypes.arrayOf(PropTypes.object),
  productName: PropTypes.string,
  viewGalleryImageEvent: PropTypes.func,
  campaign: PropTypes.string,
};

export default PDPMobileStudioPhotoGalleryUI;
